import { useLocation } from 'react-router';

import { customizeReferrerSchema } from '../../schemas';

/**
 * Retrieve the customize referrer location state from the current location.
 * This hook omits the `page` location state which is only necessary for the
 * initial animation into the customize view.
 *
 * @remarks This hook exists because now that there are nested customize routes,
 * we need to pass along the location state between those routes to preserve the
 * `referrer` which is where the user will ultimately be sent back to upon
 * exiting the customization flow.
 *
 * @returns The customize referrer location state if it is valid, otherwise
 * `undefined`.
 */
export const useCustomizeReferrerState = () => {
  const { state } = useLocation();

  return customizeReferrerSchema.isValidSync(state)
    ? {
        referrer: state.referrer,
      }
    : undefined;
};
